/**
 * Nsection B7 Service
 * B.7.政策、選項與實施計畫符合性說明 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b7';

export interface NsectionB7Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  alignment_content: string | null;
  nsection_b7_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB7Update {
  alignment_content?: string;
}

const nsectionB7Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB7Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB7Update): Promise<NsectionB7Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB7Service;
